import React, { useState, cloneElement } from "react";
import {
  List,
  ExportButton,
  RefreshButton,
  TopToolbar,
  Datagrid,
  TextField,
  ReferenceInput,
  AutocompleteInput,
  ReferenceField,
  DateField,
  CreateButton,
  ShowButton,
  Filter,
  TextInput,
  BooleanField,
  SelectInput,
  GET_ONE,
  useRecordContext,
  useResourceContext,
  useTranslate,
} from "react-admin";
import { Scrollbars } from "react-custom-scrollbars";
import {
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
  getLocalStorageKey,
} from "../common/common";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useLocation } from "react-router-dom";

const PlantsListFilter = (props) => (
  <Filter {...props}>
    <TextInput source="name" />
    <TextInput source="plant_code" />
    <SelectInput
      label="Rocks Active"
      source="is_rocks_enable"
      choices={[
        { id: true, name: "ON" },
        { id: false, name: "OFF" },
      ]}
    />
  </Filter>
);

const ListActions = (props) => {
  const location = useLocation();
  const resource = useResourceContext();

  const [modalShow, setModalShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [customFilterUrl, setCustomFilterUrl] = useState(location.search);

  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    console.log("...", location.pathname, `${apiUrl}/${resource}_list_csv`);
    options.method = "GET";
    let _url = location.pathname.split("?");
    if (_url.length > 1 && _url[1] !== "") {
      console.log("params found");

      setCustomFilterUrl(_url[1], () => {
        fetch(`${apiUrl}/${resource}_list_csv?${customFilterUrl}`, options)
          .then((res) => {
            return res.json();
          })
          .then((jsonD) => {
            console.log("json= inside callback", jsonD.data);
            const msg = jsonD.data ? jsonD.data[0].message : "";
            Swal.fire({
              html: msg,
              icon: "success",
            });
          });
      });
    } else {
      setCustomFilterUrl(location.search);
      fetch(`${apiUrl}/${resource}_list_csv?${location.search}`, options)
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
        });
    }
  };

  const onClose = () => {
    setModalShow(false);
  };

  const {
    filterValues,
    total,
    maxResults,
    currentSort,
    exporter,
    permanentFilter,
    showFilter,
    displayedFilters,
    filters,
    basePath,
  } = props;
  const csvResource = resource + "_list_csv";
  const translate = useTranslate();

  console.log("resourceData", JSON.stringify(resource))

  return (
    <React.Fragment>
      <TopToolbar>
        {filters &&
          cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: "button",
          })}
        <RefreshButton />
        {/* <CreateButton basePath={basePath} /> */}
        {/* <div>
          <button
            className="export-button"
            onClick={(e) => callExport(e)}
            disabled={total === 0}
            sort={currentSort}
            filter={{ ...filterValues, ...permanentFilter }}
          >
            {<GetAppIcon />}
            <span>{translate("resources.users.fields.export")}</span>
          </button>
        </div> */}
      </TopToolbar>
      {modalShow && (
        <Modal open={modalShow} onClose={onClose} center>
          <h3>{modalMsg}</h3>
        </Modal>
      )}
    </React.Fragment>
  );
};

const SettingChangeToggle = () => {
  const record = useRecordContext();
  const apiUrl = RUN_TIME_API_ENDPOINT;
  const recordValue = record?.is_rocks_enable ? "ON" : "OFF";

  const handleTogglePress = (event) => {
    event.stopPropagation();
    const url = `${apiUrl}/sap_plants/${record.id}/update_status`;
    const data = {
      is_rocks_enable: event.target.checked,
    };
    const options = CommonHeaderOption();
    options.method = "PATCH";
    options.body = JSON.stringify(data);

    Swal.fire({
      text: "Please wait while your request is being processed.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    fetch(url, options)
      .then((res) => {
        if (res.status === 401) {
          localStorage.removeItem("__state");
          window.location.href = "#/login";
        }
        return res.json();
      })
      .then((json) => {
        console.log("json ===>", json);
        window.location.reload();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Unable to process your request at this time. Please try again later.",
        });
        console.log(error);
      });
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <div
        className={`toggle-button-container ${
          recordValue === "ON" ? "toggle-button-on" : ""
        }`}
      >
        <label className="switch">
          <input
            type="checkbox"
            checked={recordValue === "ON"}
            onChange={handleTogglePress}
          />{" "}
          <div></div>
        </label>
        <span className="switch-status">{recordValue}</span>
      </div>
    </div>
  );
};

const PlantsList = (props) => {
  const translate = useTranslate();

  return (
    <React.Fragment>
      <Scrollbars class="scroll-container">
        <List
          sort={{ field: "created_at", order: "DESC" }}
          filters={<PlantsListFilter />}
          // title={translate("resources.plant.fields.name")}
          title={translate("Asphalt Plant List")}
          resource="sap_plants"
          actions={<ListActions permissions={props} />}
        >
          <Datagrid
            bulkActionButtons={false}
            rowClick={(id, resource, record) => `/sap_plants/${record.id}`}
          >
            <TextField source="name" />
            <TextField source="plant_code" />
            <SettingChangeToggle source="sett_value" label="Rocks Active" />
          </Datagrid>
        </List>
      </Scrollbars>
    </React.Fragment>
  );
};

export default PlantsList;
